import { render, staticRenderFns } from "./brank.vue?vue&type=template&id=127b0f55&scoped=true"
import script from "./brank.vue?vue&type=script&lang=js"
export * from "./brank.vue?vue&type=script&lang=js"
import style0 from "./brank.vue?vue&type=style&index=0&id=127b0f55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127b0f55",
  null
  
)

export default component.exports